module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAkCAYAAAD7PHgWAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADFSURBVFiF7dhBDoMgEIXhN9y1i+56lB6SRW8x3TaoOMMblCbzbw34BYUYBWSqqr3rIiLM/IUZfEUJZEsgWwLZEsiWQLZDoKq+1NDZDSxzqOp7SG9Fko3hLkJyuMnIGNwkZCwuGOnDtaMnI09xG48XSCBNKxcCHECaH2sY0IF0vXOhQAPSvVvDgR3k0FEyBbiDHD7npgF/kNQh3HqkRbF/Athaz/9+D65SAtmWB2528Wotv4IFwOduRKdaADwA1LslO1UAzy8S1iq2sQ2ScwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/icon_down2.png
// module id = RtbH
// module chunks = 1